/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState, useContext } from 'react';

import { Grid, makeStyles } from '@material-ui/core';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from '../../../styles/Layout.module.css';
import routing from '../../../service/routes/routing';
import EditLegalEntityForm from './components/EditLegalEntityForm';
import api from '../../../service/axios/api';
import Loading from '../../../components/loading/Loading';
import FlashContext from '../../../components/contexts/FlashContext';

const useStyles = makeStyles(theme => ({
  header: {
    marginBottom: theme.spacing(2),
  },
  selectField: {
    minWidth: '200px',
  },
}));

function EditAwardLegalEntity() {
  const { t } = useTranslation();
  const { notifyError } = useContext(FlashContext);
  const router = useHistory();
  const classes = useStyles();
  const { id } = useParams();

  const [awardee, setAwardee] = useState();
  const [loading, setLoading] = useState(false);

  const getAwardee = async (awardeeId) => {
    setLoading(true);
    const cancel = new AbortController();

    try {
      const response = await api.contract.getSingleAwardLegalEntity(cancel, awardeeId);
      
      if(response.docs) setAwardee(response.docs)
    } catch (error) {
      notifyError(error.message);
    } finally{
      setLoading(false);
    }
  };

  useEffect( async () => {
    if (id) {
      await getAwardee(id);
    }
  }, [id]);

  return (
    <>
      <Loading open={loading} msg={t('editContractAward.searchMsg')} />
      <Grid
        className={classes.header}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        style={{ marginTop: 50 }}
      >
        <p
          className={styles.textMenu}
          onKeyDown={() =>
            router.push(routing.contractAwards)
          }
          onClick={() =>
            router.push(routing.contractAwards)
          }
        >
          Menu Inicial
        </p>
        <div
          className="col-sm-12"
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <h4 className={styles.textTitle}>{t('editContractAward.label')}</h4>
        </div>
      </Grid>
      {awardee && ( <EditLegalEntityForm legalEntity={awardee} />
      )}
    </>
  );
}

export default EditAwardLegalEntity;
